/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderDomainCentrePairData
 */
export interface OrderDomainCentrePairData {
    /**
     * 
     * @type {string}
     * @memberof OrderDomainCentrePairData
     */
    domainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDomainCentrePairData
     */
    domainName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDomainCentrePairData
     */
    domainEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDomainCentrePairData
     */
    centreId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDomainCentrePairData
     */
    centreName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDomainCentrePairData
     */
    centreSlug?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDomainCentrePairData
     */
    orderCount?: number;
}

/**
 * Check if a given object implements the OrderDomainCentrePairData interface.
 */
export function instanceOfOrderDomainCentrePairData(value: object): value is OrderDomainCentrePairData {
    return true;
}

export function OrderDomainCentrePairDataFromJSON(json: any): OrderDomainCentrePairData {
    return OrderDomainCentrePairDataFromJSONTyped(json, false);
}

export function OrderDomainCentrePairDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDomainCentrePairData {
    if (json == null) {
        return json;
    }
    return {
        
        'domainId': json['domainId'] === undefined ? undefined : json['domainId'] === null ? null : json['domainId'],
        'domainName': json['domainName'] == null ? undefined : json['domainName'],
        'domainEnabled': json['domainEnabled'] === undefined ? undefined : json['domainEnabled'] === null ? null : json['domainEnabled'],
        'centreId': json['centreId'] == null ? undefined : json['centreId'],
        'centreName': json['centreName'] == null ? undefined : json['centreName'],
        'centreSlug': json['centreSlug'] == null ? undefined : json['centreSlug'],
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
    };
}

export function OrderDomainCentrePairDataToJSON(json: any): OrderDomainCentrePairData {
    return OrderDomainCentrePairDataToJSONTyped(json, false);
}

export function OrderDomainCentrePairDataToJSONTyped(value?: OrderDomainCentrePairData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domainId': value['domainId'],
        'domainName': value['domainName'],
        'domainEnabled': value['domainEnabled'],
        'centreId': value['centreId'],
        'centreName': value['centreName'],
        'centreSlug': value['centreSlug'],
        'orderCount': value['orderCount'],
    };
}

